import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';
import InfoEvents from './InfoEvents';
import Settings from './Settings';

class HeaderRightNav extends Component {
  constructor(props) {
    super(props);

    // this.state = {
    //   noticesOpened: false,
    //   settingsOpened: false,
    //   moreOpened: false,
    // };
  }

  render() {
    return (
        <nav className="header__nav">
          <ul>
            <InfoEvents/>
            <Settings/>
          </ul>
        </nav>
    );
  }

  handleClickOutside() {
    // this.setState({
    //   settingsOpened: false,
    //   moreOpened: false,
    // });
  }
}

export default onClickOutside(HeaderRightNav);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderRightNav/index.js